import { getDeviceFingerprint } from './deviceFingerprint'
import { getAppVersion } from './helpers'
import { IUserDevice } from './types'
import { ClientJS } from 'clientjs'

const getDeviceType = () => {
  const ua = navigator.userAgent
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet'
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'Mobile Browser'
  }
  return 'Desktop'
}

const client = new ClientJS()

/**
 * Builds the device descriptor sent alongside the x-kp header on session-minting
 * requests. Field names come from a shared mobile/web API contract, so several do
 * not mean what they look like -- see IUserDevice for the per-field semantics.
 *
 * uniqueId must stay byte-for-byte identical to the x-kp header or backend device
 * matching silently breaks.
 */
export const getUserDevice = (): IUserDevice => ({
  // appVersion: getAppVersion(),
  uniqueId: getDeviceFingerprint(),
  device: client.getOS(),
  systemName: getDeviceType(),
  useragent: client.getUserAgent(),
  type: 'web',
  brand: client.getBrowser(),
  systemVersion: client.getOSVersion(),
  language: navigator.language,
})
